var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_2739",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_2739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 18.3334C4.30556 18.3334 3.71528 18.0904 3.22917 17.6042C2.74306 17.1181 2.5 16.5279 2.5 15.8334V15.0001C2.5 14.5417 2.66319 14.1494 2.98958 13.823C3.31597 13.4966 3.70833 13.3334 4.16667 13.3334H5V3.33341C5 2.87508 5.16319 2.48272 5.48958 2.15633C5.81597 1.82994 6.20833 1.66675 6.66667 1.66675H15.8333C16.2917 1.66675 16.684 1.82994 17.0104 2.15633C17.3368 2.48272 17.5 2.87508 17.5 3.33341V15.8334C17.5 16.5279 17.2569 17.1181 16.7708 17.6042C16.2847 18.0904 15.6944 18.3334 15 18.3334H5ZM15 16.6667C15.2361 16.6667 15.434 16.5869 15.5938 16.4272C15.7535 16.2674 15.8333 16.0695 15.8333 15.8334V3.33341H6.66667V13.3334H12.5C12.9583 13.3334 13.3507 13.4966 13.6771 13.823C14.0035 14.1494 14.1667 14.5417 14.1667 15.0001V15.8334C14.1667 16.0695 14.2465 16.2674 14.4062 16.4272C14.566 16.5869 14.7639 16.6667 15 16.6667ZM8.33333 7.50008C8.09722 7.50008 7.89931 7.42022 7.73958 7.2605C7.57986 7.10078 7.5 6.90286 7.5 6.66675C7.5 6.43064 7.57986 6.23272 7.73958 6.073C7.89931 5.91328 8.09722 5.83342 8.33333 5.83342H14.1667C14.4028 5.83342 14.6007 5.91328 14.7604 6.073C14.9201 6.23272 15 6.43064 15 6.66675C15 6.90286 14.9201 7.10078 14.7604 7.2605C14.6007 7.42022 14.4028 7.50008 14.1667 7.50008H8.33333ZM8.33333 10.0001C8.09722 10.0001 7.89931 9.92022 7.73958 9.7605C7.57986 9.60078 7.5 9.40286 7.5 9.16675C7.5 8.93064 7.57986 8.73272 7.73958 8.573C7.89931 8.41328 8.09722 8.33342 8.33333 8.33342H14.1667C14.4028 8.33342 14.6007 8.41328 14.7604 8.573C14.9201 8.73272 15 8.93064 15 9.16675C15 9.40286 14.9201 9.60078 14.7604 9.7605C14.6007 9.92022 14.4028 10.0001 14.1667 10.0001H8.33333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContract);
export default __webpack_public_path__ + "static/media/icon_contract.d3c5e3f36976c3379ba824d87f707721.svg";
export { ForwardRef as ReactComponent };